import React, { Component } from "react";
import "./CustomHeroCard.css";
import CustomHeroCardButtonCol from "./CustomHeroCardButtonCol";
import CustomHeroCardButtonRow from "./CustomHeroCardButtonRow";
import ReactHtmlParser from "react-html-parser";
var md = require("markdown-it")({
  html: true,
  linkify: true,
  typographer: true,
});
var mila = require("markdown-it-link-attributes");
md.use(mila, [{
  matcher(href, config) {
    return href.startsWith("https://chatapps");
  },
  attrs: {   
    rel: "noopener",
    class: "internal-link"
  },
},
{
  matcher(href, config) {
    return !href.startsWith("https://chatapps");
  },
  attrs: {
    target: "_blank",
    rel: "noopener",
    class: "external-link"
  },
}]);
// var defaultRender =
//   md.renderer.rules.link_open ||
//   function (tokens, idx, options, env, self) {
//     return self.renderToken(tokens, idx, options);
//   };

// md.renderer.rules.link_open = function (tokens, idx, options, env, self) {
//   console.log("customer card")
//   // If you are sure other plugins can't add `target` - drop check below
//   var aIndex = tokens[idx].attrIndex("target");
//   if (aIndex < 0) {
//     tokens[idx].attrPush(["target", "_blank"]); // add new attribute
//   } else {
//     tokens[idx].attrs[aIndex][1] = "_blank"; // replace value of existing attr
//   }
//   // pass token to default renderer.
//   return defaultRender(tokens, idx, options, env, self);
// };
const ADDLINK_URL = process.env.REACT_APP_API_URL + "/links";
const RECORD_RECOMMENDER = process.env.REACT_APP_API_URL + "/recommender-stats";
export default class CustomHeroCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showmore: false,
    };
    this.action = this.action.bind(this);
    this.showmore = this.showmore.bind(this);
    this.showless = this.showless.bind(this);
  }

  showmore() {
    this.setState({ showmore: true });
  }
  showless() {
    this.setState({ showmore: false });
  }

  action(button) {    
    if (
      button.type.toLowerCase() == "openUrl".toLowerCase() &&
      button.value.includes(":Webview") !== true
    ) {     
      if (button.value.includes("utm_source") === false) {
        if (button.value !== "" && this.props.googleAnalytics !== undefined) {
          var options = button.value.lastIndexOf("&");
          if (button.value.indexOf("?") == "-1") {
            button.value =
              button.value +
              `?utm_source=${
                this.props.googleAnalytics.utmSource !== undefined
                  ? this.props.googleAnalytics.utmSource
                  : ""
              }&utm_medium=${
                this.props.googleAnalytics.utmMedium !== undefined
                  ? this.props.googleAnalytics.utmMedium
                  : ""
              }`;
          } else if (button.value.indexOf("&") == "-1") {
            button.value =
              button.value +
              `&utm_source=${
                this.props.googleAnalytics.utmSource !== undefined
                  ? this.props.googleAnalytics.utmSource
                  : ""
              }&utm_medium=${
                this.props.googleAnalytics.utmMedium !== undefined
                  ? this.props.googleAnalytics.utmMedium
                  : ""
              }`;
          } else {
            button.value =
              button.value.substr(0, button.value.lastIndexOf("&")) +
              `&utm_source=${
                this.props.googleAnalytics.utmSource !== undefined
                  ? this.props.googleAnalytics.utmSource
                  : ""
              }&utm_medium=${
                this.props.googleAnalytics.utmMedium !== undefined
                  ? this.props.googleAnalytics.utmMedium
                  : ""
              }` +
              button.value.substr(button.value.lastIndexOf("&"));
          }
        }
      }
    }
    if (button.type === "imBack") {
      this.props.api.sendActivity({
        type: "WEB_CHAT/SEND_MESSAGE",
        payload: {
          text: button.value,
        },
      });
      setTimeout(() => {
        if (
          document.querySelector("ul.webchat__basic-transcript__transcript") !==
          null
        ) {
          document
            .querySelector("ul.webchat__basic-transcript__transcript")
            .lastChild.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 500);
    } else if (button.type.toLowerCase() === "openurl") {
      if (button.type == "openUrl" && button.value.includes(":Webview")) {
        // Hero Card Webview
        if (button.value.includes("ServiceView")) {
          this.props.servicePopup();
        } else {
          this.props.addLinks(button.value);
          var url = button.value;
          var indexWebView = url.indexOf(":Webview");
          var jsonData = JSON.parse(url.substring(indexWebView + 8));
          var webViewUrl = url.substring(0, indexWebView);
          this.props.api.sendActivity({
            type: "WEB_CHAT/SEND_EVENT",
            payload: {
              name: "webchat/openWebView",
              value: {
                url: `${webViewUrl}`,
                title: jsonData.title,
                mode: jsonData.mode,
                largeWindowHideHeader:
                  jsonData.largeWindowHideHeader !== undefined
                    ? jsonData.largeWindowHideHeader
                    : false,
              },
            },
          });
        }
      } else {
        this.props.addLinks(button.value);
        if (
          button.value.toLowerCase().includes("chatapps") &&
          button.value.toLowerCase().includes("bookmebob.com")
        ) {
          this.props.api.sendActivity({
            type: "WEB_CHAT/SEND_EVENT",
            payload: {
              name: "webchat/openWebView",
              value: {
                url: button.value,
                title: '',
                mode: 'Normal',
                largeWindowHideHeader:
                  false,
              },
            },
          });
        } else {
          if (window.parent) {
            window.parent.postMessage(`openUrl:${button.value}`, "*");
          } else {
            window.location = button.value;
          }
        }
      }
    } else if (button.type.toLowerCase() === "messageback") {
      var data = JSON.parse(button.value);
      //console.log(data)
      if (data.type === "availblity") {
        this.props.availblityForm(data);
        let body = {
          GroupId: data.gid,
          PropertyId: data.pid,
          Button: data.clickButton,
          Creator: "api",
        };

        body.roomId = data.roomId;
        if (data.id !== undefined && data.id !== "") {
          body.SetId = data.id;
        }

        fetch(RECORD_RECOMMENDER, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        });
      } else {
        if (data.type === "webView") {
          this.props.api.sendActivity({
            type: "WEB_CHAT/SEND_EVENT",
            payload: {
              name: "webchat/openWebView",
              value: {
                url: `${data.url}`,
                title: `${button.title}`,
                mode: "Normal",
                largeWindowHideHeader: true,
              },
            },
          });
        } else if (data.type === "askaquestion") {
          this.props.bookingApp.selectedPid = data.pid;
          this.forceUpdate();
          localStorage.setItem(
            this.props.bookingApp.lStore.PROPERTYID,
            data.pid
          );
          localStorage.setItem(
            this.props.bookingApp.lStore.PROPERTYNAME,
            data.name
          );
          this.props.bookingApp.callbacks.getStore().dispatch({
            type: "WEB_CHAT/SEND_EVENT",
            payload: {
              name: "webchat/update",
              value: {
                pid: data.pid,
                pname: data.name,
              },
            },
          });
        } else {
          this.props.addLinks(data.url);
          if (window.parent) {
            window.parent.postMessage(`openUrl:${data.url}`, "*");
          } else {
            window.location = data.url;
          }
        }

        let body = {
          GroupId: data.gid,
          PropertyId: data.pid,
          Button: data.clickButton,
          Creator: "api",
        };

        if (data.productId) {
          body.productId = data.productId;
        } else if (data.roomId) {
          body.roomId = data.roomId;
        } else if (data.promoId) {
          body.promoId = data.promoId;
        } else if (data.addonId) {
          body.addonId = data.addonId;
        }

        if (data.id !== undefined && data.id !== "") {
          body.SetId = data.id;
        }

        fetch(RECORD_RECOMMENDER, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        });
      }
    }
  }

  render() {
    const herocard = this.props.herocard;

    let imageUrl;
    if (herocard.images && herocard.images.length > 0) {
      imageUrl = herocard.images[0].url;
    }

    let webConfig = herocard.webConfig ?? {};

    let feedback_response = JSON.parse(
      localStorage.getItem(this.props.iid + "-chatfeedback")
    );
    let feedbackbody;
    if (feedback_response !== null) {
      feedbackbody = feedback_response.filter(
        (i) => i.messageId === this.props.messageId
      )[0];
    }
    return (
      <div
        className="herocard-container"
        data-activity-id={this.props.messageId}
        data-con-id={this.props.conversationId}
        data-feedback={feedbackbody !== undefined && feedbackbody.feedback}
        data-view-btn={this.props.replyToId}
        data-msg-type={this.props.cardActivitiesSummary}
        data-inzendesk={this.props.inZenDesk}
      >
        {imageUrl ? (
          <img className="herocard-image" src={imageUrl} alt="" />
        ) : (
          ""
        )}
        {herocard.title || herocard.text ? (
          <div className="herocard-text-area">
            {herocard.title ? (
              <div className="ac-textBlock herocard-title-text">
                {herocard.title}
              </div>
            ) : (
              ""
            )}
            {herocard.text ? (
              <div className="ac-textBlock">
                {!this.state.showmore &&
                  (herocard.text.length > 125
                    ? herocard.text
                        .substring(0, 125)
                        .split("\n")
                        .map(function (item, key) {
                          return (
                            <span key={key}>
                              {ReactHtmlParser(md.renderInline(item))}
                              <br />
                            </span>
                          );
                        })
                    : herocard.text.split("\n").map(function (item, key) {
                        return (
                          <span key={key}>
                            {ReactHtmlParser(md.renderInline(item))}
                            <br />
                          </span>
                        );
                      }))}

                {this.state.showmore &&
                  herocard.text.split("\n").map(function (item, key) {
                    return (
                      <span key={key}>
                        {ReactHtmlParser(md.renderInline(item))}
                        <br />
                      </span>
                    );
                  })}
                {!this.state.showmore && herocard.text.length > 125 && (
                  <div style={{ textAlign: "right" }}>
                    <a
                      style={{
                        textDecoration: "underline",
                        cursor: "pointer",
                        fontSize: "0.9em",
                      }}
                      onClick={() => {
                        this.showmore();
                      }}
                    >
                      Show More
                    </a>{" "}
                  </div>
                )}
                {this.state.showmore && (
                  <div style={{ textAlign: "right" }}>
                    <a
                      style={{
                        textDecoration: "underline",
                        cursor: "pointer",
                        fontSize: "0.9em",
                      }}
                      onClick={() => {
                        this.showless();
                      }}
                    >
                      Show Less
                    </a>
                  </div>
                )}
              </div>
            ) : (
              ""
            )}
          </div>
        ) : (
          ""
        )}
        {herocard.buttons && webConfig.actionsRow ? (
          <div className="herocard-button-row-container">
            {herocard.buttons.map((btn) => (
              <CustomHeroCardButtonRow
                btn={btn}
                botSettings={this.props.botSettings}
                action={this.action}
              />
            ))}
          </div>
        ) : (
          ""
        )}
        {herocard.buttons && !webConfig.actionsRow ? (
          <div className="herocard-button-col-container">
            {herocard.buttons.map((btn, index) => (
              <CustomHeroCardButtonCol
                key={index}
                btn={btn}
                botSettings={this.props.botSettings}
                action={this.action}
              />
            ))}
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}
